import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ConfirmationPage = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const {
		Name,
		MobileNo,
		UserAddress,
		subtotal = 0,
		ProductData = [],
		OrderDate,
		orderID,
	} = location.state || {};

	const handleContinue = () => {
		navigate('/dashboard', { replace: true });
	};

	const handleDetails = () => {
		navigate('/order-history', { replace: true });
	};

	const overallTotal = ProductData.reduce((total, product) => {
		const totalPrice =
			product.OrderDetails?.reduce((sum, item) => sum + (item.Qty * item.DiscountMRP || 0), 0) || 0;

		return total + totalPrice;
	}, 0);

	return (
		<div className='flex justify-center items-center mb-32 mt-10'>
			<div className='md:w-[550px] w-[500px] max-sm:w-[90%] max-[300px]:w-[95%] bg-white md:px-10 px-5 max-[300px]:px-1.5 py-4 rounded-lg shadow-2xl'>
				<div className='flex flex-col justify-center items-center mb-4'>
					<p className='md:text-4xl text-3xl max-[440px]:text-2xl max-[330px]:text-xl font-semibold text-red-500 md:mb-4 mb-2 uppercase'>
						Order Confirmation
					</p>
					<p className='md:text-[26px] text-[22px] font-semibold mb-2 max-[440px]:text-lg max-[330px]:text-base'>
						Thank you for your order!
					</p>
					<p className='md:text-lg text-sm max-[440px]:text-[13px] max-[330px]:text-xs'>
						Your order has been successfully placed.
					</p>
				</div>
				<div className='flex flex-col md:mb-4 mb-2'>
					<p className='md:text-xl text-lg max-[440px]:text-sm  max-[330px]:text-xs font-semibold mb-2'>
						Order Summary
					</p>
					<p className='md:text-lg text-sm max-[440px]:text-[13px] max-[330px]:text-xs font-medium mb-3 '>
						Order Number: <span className='font-normal ml-2'>{orderID}</span>
					</p>
					<p className='md:text-lg text-sm max-[440px]:text-[13px] max-[330px]:text-xs font-medium '>
						Order Date: <span className=' font-normal ml-2'>{OrderDate}</span>
					</p>
				</div>
				<div className='flex flex-col md:mb-4 mb-2 mt-2'>
					<p className='md:text-xl text-lg font-semibold max-[440px]:text-base max-[330px]:text-sm mb-2'>
						Items Purchased:
					</p>
					<table className='w-full  md:text-[13px] text-xs max-[440px]:text-[10px] '>
						<thead>
							<tr className='border'>
								<th className=' px-4 py-2 max-[440px]:px-2 text-left border '>Product Name</th>
								<th className=' px-4 py-2 max-[440px]:px-2 text-left border '>Color</th>
								<th className=' px-4 py-2 max-[440px]:px-2 text-center border '>Size</th>
								{/* <th className=" px-4 py-2 text-left">Discount MRP</th> */}
								<th className=' px-4 py-2 max-[440px]:px-2 text-left border '>Quantity</th>
								<th className=' px-4 py-2 max-[440px]:px-2 text-center border '>Total</th>
							</tr>
						</thead>
						{/* <tbody>
							{ProductData.map((product, index) => (
								<tr key={index} className='border '>
									<td className=' px-4 py-1 max-[440px]:px-2 border'>{product.ProductName}</td>
									<td className=' px-4 py-1 max-[440px]:px-2 border'>{product.Color}</td>
									<td className='px-4 py-1 text-center max-[440px]:px-2 border '>{product.Size}</td>
									<td className=' px-4 py-1 text-center max-[440px]:px-2 border'>{product.Qty}</td>
									<td className=' px-4 py-1 max-[440px]:px-2 border'>
										<span className='font-sans'>₹</span>
										{(product.DiscountMRP * product.Qty).toFixed(2)}
									</td>
								</tr>
							))}
						</tbody> */}
						<tbody className='text-sm'>
							{ProductData.map((product, index) => {
								const totalQty = product.OrderDetails.reduce((sum, order) => sum + order.Qty, 0);
								const totalPrice =
									product.OrderDetails?.reduce(
										(sum, item) => sum + item.Qty * item.DiscountMRP,
										0
									) || 0;

								return (
									<React.Fragment key={index}>
										{/* Product Name Row */}
										<tr className='bg-gray-100 border'>
											<td className='px-4 py-1 max-[440px]:px-2 font-medium border' colSpan={5}>
												{product.ProductName?.length > 30
													? product.ProductName.slice(0, 30) + '...'
													: product?.ProductName}
											</td>
										</tr>

										{/* Order Details */}
										{product.OrderDetails.map((order, orderIndex) => (
											<tr key={`${index}-${orderIndex}`} className='border text-center'>
												<td className='px-4 py-1 max-[440px]:px-2 border'></td>
												<td className='px-4 py-1 max-[440px]:px-2 border'>{order.color}</td>
												<td className='px-4 py-1 max-[440px]:px-2 text-center border'>
													{order.size || 'N/A'}
												</td>
												<td className='px-4 py-1 max-[440px]:px-2 border text-center'>
													{order.Qty}
												</td>
												<td className='px-4 py-1 max-[440px]:px-2 text-center border'>
													<span className='font-sans text-sm'> ₹</span>
													{(order.DiscountMRP * order.Qty).toLocaleString('en-IN', {
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													})}
												</td>
											</tr>
										))}

										{/* Product-wise Total Row */}
										<tr className='border font-medium bg-gray-200'>
											<td className='px-4 py-1 max-[440px]:px-2 text-right border' colSpan={3}>
												Total:
											</td>
											<td className='px-4 py-1 max-[440px]:px-2 text-center border'>{totalQty}</td>
											<td className='px-4 py-1 max-[440px]:px-2 text-center border'>
												<span className='font-sans text-base'> ₹ </span>
												{totalPrice.toLocaleString('en-IN', {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												})}
											</td>
										</tr>
									</React.Fragment>
								);
							})}

							{/* Grand Total Row */}
							<tr className='border-t-2 border-black font-medium bg-gray-100'>
								<td className='px-4 py-1 max-[440px]:px-2 text-right border' colSpan={3}>
									Grand Total:
								</td>
								<td className='px-4 py-1 max-[440px]:px-2 text-center border'>
									{ProductData.reduce(
										(sum, product) =>
											sum + product.OrderDetails.reduce((qtySum, order) => qtySum + order.Qty, 0),
										0
									)}
								</td>
								<td className='px-4 py-1 max-[440px]:px-2 text-center border'>
									<span className='font-sans text-base'>₹ </span>
									{overallTotal.toLocaleString('en-IN', {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									})}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className='flex flex-row justify-between items-center font-semibold md:text-lg max-[330px]:text-xs text-sm mb-2'>
					<p>Shipping Address:</p>
					<p>Total:</p>
				</div>
				<div className='flex flex-row justify-between items-center font-semibold md:text-base max-[330px]:text-[13px] text-sm mb-2'>
					<p className='uppercase'>
						{Name}
						{/* {newCustomer} */}
					</p>
					<p className=' text-sm'>
						Total Qty :<span></span> <span></span>
						{ProductData.reduce(
							(sum, product) =>
								sum + product.OrderDetails.reduce((qtySum, order) => qtySum + order.Qty, 0),
							0
						)}
					</p>
				</div>
				<div className='flex flex-row justify-between items-center font-semibold md:text-base max-[330px]:text-[13px] text-sm mb-2'>
					<p>{UserAddress}</p>
					<p className=' text-sm'>
						Subtotal: <span className='font-sans text-base'>₹ </span>
						{overallTotal.toLocaleString('en-IN', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})}
					</p>
				</div>
				<div className='font-semibold md:text-base text-sm max-[300px]:text-[13px] mb-4 max-[330px]:mb-2'>
					<p>Mobile No: {MobileNo}</p>
				</div>
				<div className='flex flex-row justify-between items-center sm:mb-4 gap-2 max-[400px]:gap-0 max-[440px]:flex-col'>
					<button onClick={handleContinue} className='proBtn w-full'>
						Continue Shopping
					</button>
					<button onClick={handleDetails} className='proBtn w-full '>
						View Order Details
					</button>
				</div>
			</div>
		</div>
	);
};

export default ConfirmationPage;
